/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ArrowRight/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ArrowRight({
  children,
  viewPath = "/DesignSystem/Svgs/ArrowRight",
  alignSelf = "auto",
  height = 16,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  opacity = 1,
  width = 16,
  fill = "none",
  stroke = "#B5B5B5"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="ArrowRight.ArrowRight:1"
  data-view-path={viewPath}
 viewBox="0 0 16 16"
 style={{'--as-1-iaeGf': alignSelf,'--h-2-iaeGf': typeof height === 'number' ? `${height}px` : height,'--mb-3-iaeGf': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-iaeGf': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-iaeGf': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-6-iaeGf': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--o-7-iaeGf': opacity,'--w-8-iaeGf': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.ArrowRight1}`}
>
<path
  data-testid="ArrowRight.SvgPath"
  data-view-path={viewPath}
 d="M4.8 1.6L11.2 8l-6.4 6.4"
 strokeMiterlimit={10}
 strokeWidth={2}
 style={{'--f-9-iaeGf': fill,'--s-10-iaeGf': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}